import { render, staticRenderFns } from "./Settlement.vue?vue&type=template&id=7b6204a0&scoped=true&"
import script from "./Settlement.vue?vue&type=script&lang=js&"
export * from "./Settlement.vue?vue&type=script&lang=js&"
import style0 from "./Settlement.vue?vue&type=style&index=0&id=7b6204a0&lang=scss&scoped=true&"
import style1 from "./Settlement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6204a0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SettlementSubTab: require('/codebuild/output/src2428694706/src/cc-portal/components/SettlementSubTab.vue').default,CpdSendConfirmDialog: require('/codebuild/output/src2428694706/src/cc-portal/components/CpdSendConfirmDialog.vue').default})
